import React, { KeyboardEvent, useEffect, useRef } from "react";
import "./style.scss";
import { useTranslation } from "react-i18next";
import { ReactComponent as ClearImg } from "../../assets/icons/x.svg";
import Keyboard from "../Keyboard";
import orderStore from "../../stores/order";
import { observer } from "mobx-react";
import { cutScannerData } from "../../helpers/orderHelper";

export interface EnterAuthCodeProps {
    goNext?: () => void;
}

const EnterAuthCode = ({goNext}: EnterAuthCodeProps) => {
    const [t] = useTranslation();
    const inputRef = useRef(null);
    const clearRef = useRef(null);

    let timer: NodeJS.Timeout;

    useEffect(() => {
        timer = setInterval(() => {
            setFocusToInput();
        }, 500);
        setFocusToInput();

        return () => {
            clearInterval(timer);
        }
    }, []);

    const setFocusToInput = () => {
        if (inputRef.current) {
            const input = inputRef.current as unknown as HTMLInputElement;
            input.focus();
        }
    }

    const onChangeTextInput = (text: string) => {
        const isGoNext = !orderStore.customerCode.length && text.length > 3;
        onChangeText(text);

        if (isGoNext && typeof goNext === "function")
            goNext();
    }

    const onChangeText = (text: string) => {
        text = cutScannerData(text);
        orderStore.changeCustomerCode(text);
    }

    const keyDown = (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter" && typeof goNext === "function")
            goNext();
    }

    return <div className="EnterAuthCode">
        <div className="title">{t('enterCode')}</div>
        <div className="description">{t('enterCodeDescription')}</div>
        <div className="inputContainer">
            <div className="input">{orderStore.customerCode}</div>
            <ClearImg ref={clearRef} className="clear"/>
        </div>
        <input ref={inputRef} className="inputHide" type="text" value={orderStore.customerCode} onChange={(e) => onChangeTextInput(e.target.value)} onKeyDown={keyDown} />
        <Keyboard clearRef={clearRef} onChangeText={onChangeText} text={orderStore.customerCode} />
    </div>
}

export default observer(EnterAuthCode);
